import React, { useState } from "react";
import { InputSwitch } from "primereact/inputswitch";
import { Divider } from "primereact/divider";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";

const FileUploadComponent = ({
  onSave,
  closeSidebar,
  fieldName,
  required,
  fileType,
}) => {
  const [isRequired, setIsRequired] = useState(required || false);
  const [selectedFileType, setSelectedFileType] = useState(fileType || "all");

  const handleSave = () => {
    const fieldData = {
      name: fieldName,
      type: "fileupload",
      required: isRequired,
      fileType: selectedFileType,
    };
    const saveSuccessful = onSave(fieldData);
    if (saveSuccessful) {
      closeSidebar();
    }
  };

  return (
    <div className="p-field">
      <Divider />
      <div className="p-field mb-3">
        <label htmlFor="fields" className="block text-900 font-medium mb-2">
          Choose File Type :
        </label>
        <Dropdown
          filter
          id="filetype"
          value={selectedFileType}
          options={[
            { label: "All File Type", value: "all" },
            { label: "Image", value: "image" },
            { label: "Video", value: "video" },
            { label: "Json", value: "json" },
            { label: "Csv", value: "csv" },
            { label: "Pdf", value: "pdf" },
          ]}
          onChange={(e) => setSelectedFileType(e.value)}
          default="All File Type"
          className="w-full mb-3"
        />
      </div>
      <Divider />
      <div className="p-field-checkbox mb-3">
        <label className="font-medium" htmlFor="required">
          Required :{" "}
        </label>
        <InputSwitch
          inputId="required"
          checked={isRequired}
          onChange={(e) => setIsRequired(e.value)}
          style={{ marginLeft: "1rem", marginTop: "0.5rem" }}
        />
      </div>
      <Divider />
      <Button
        label="Save"
        icon="pi pi-check"
        style={{
          color: "#fff",
          backgroundColor: "#0D2E4D",
          border: "none",
          fontFamily: "poppins",
        }}
        onClick={handleSave}
      />
    </div>
  );
};

export default FileUploadComponent;
